import { Box } from '@mui/material';
import { InformationPad } from '../../../components/shared';
import { rentDetailsFields } from '../../../constants/rentDetailsConfig';

const LeaseDetailAccordion = (props) => {
  const { leaseInfo } = props;
  const lease = leaseInfo?.contract;

  return (
    <Box>
      <InformationPad
        data={rentDetailsFields(lease?.rentType, lease)}
        headingColumn={{ xs: 12, sm: 4, lg: 2 }}
        titleColumn={{ xs: 12, sm: 8, lg: 10 }}
      />
    </Box>
  );
};

export default LeaseDetailAccordion;
